// The portal is closed. Registering a worker again here would make public/service-worker.js
// (which unregisters itself and reloads the page) run on every load; instead the closure page
// only removes what an earlier visit installed, so its reload lands on this page once.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(registrations => Promise.all(registrations.map(r => r.unregister())))
    .catch(() => {});
  if ('caches' in window) {
    window.caches.keys()
      .then(names => Promise.all(names.map(name => window.caches.delete(name))))
      .catch(() => {});
  }
}
